import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { Tenant } from '@kawai/shared';
import { fetchTenantById } from '../repositories/tenants.js';

/**
 * 単一テナント doc（read 専用）の React Query hook。
 *
 * cache key は `['tenant', tenantId]`。明細ページのように 1 テナントだけ要るときに
 * 全件取得（`useTenants`）を避けて O(1) read にする。tenantId 未確定（空文字）の間は fetch しない。
 */
export function useTenant(
  tenantId: string,
): UseQueryResult<Tenant | null, Error> {
  return useQuery({
    queryKey: ['tenant', tenantId],
    queryFn: () => fetchTenantById(tenantId),
    enabled: tenantId !== '',
  });
}
